import { useUserStore } from "../stores/user"
import { useRouter } from "vue-router"
import { url } from "../helper"

export function useLogout(routerInstance: ReturnType<typeof useRouter>) {
	const router = useRouter()
	const userStore = useUserStore()

	const logout = async () => {
		const refreshToken = localStorage.getItem("jwt")
		const clientId = "zQTiAtJD02-HEn6fvUTE_I2Y5iKFkA9qJN4vkVDKNbI"

		try {
			// Revoke the refresh token server-side
			await fetch(`${url}/oauth/logout`, {
				method: "POST",
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
				body: new URLSearchParams({
					token: refreshToken || "",
					client_id: clientId,
				}),
			})
		} catch (err) {
			console.warn("Could not revoke token — proceeding to clear locally:", err)
		}

		// Clear storage
		localStorage.removeItem("jwt")
		localStorage.removeItem("refresh_token")
		localStorage.removeItem("token_expiry")

		sessionStorage.removeItem("pkce_code_verifier")
		sessionStorage.removeItem("post_login_redirect")

		// Clear Pinia store
		userStore.userLogout()
		// const logoutUrl = `${url}/user/logout/confirm?` +
		//   `destination=https://localhost:5175/`;

		// Redirect user to IdP logout
		// window.location.href = logoutUrl;

		// Redirect
		router.push({ name: "Home" })
	}

	return {
		logout,
	}
}
